import RouteWrapper from "@/components/common/RouteWrapper.vue";
import sidebarData from "@/data/sidebar";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";
import RouteNames from "@/entities/RouteNames";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";

const Calendar = () =>
  import("@/views/calendar/ManagementCalendar.vue").then((m) => m.default);
const ManagerCalendar = () =>
  import("@/views/calendar/ManagerCalendar.vue").then((m) => m.default);
const admin = sidebarData.find(
  (a) =>
    (a.role.includes(Roles.ADMIN) || a.role.includes(Roles.MANAGER)) &&
    a.slug === "/manage"
);
const contractor = sidebarData.find((a) => a.role.includes(Roles.CONTRACTOR));
const ContractorCalendar = () =>
  import("@/views/calendar/ContractorCalendar.vue").then((m) => m.default);

// Changed path from calendar to scheduler
const getSchedulerRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/scheduler",
    component: RouteWrapper,
    meta: {
      title: "Scheduler",
      requiresAuth: true,
      breadcrumb: {
        title: (user) =>
          user?.role === Roles.CONTRACTOR
            ? (contractor.title as string)
            : (admin.title as string),
        routeName: (user) =>
          user?.role === Roles.CONTRACTOR
            ? RouteNames.CONTRACTOR_CALENDAR
            : RouteNames.CALENDAR,
        isStyled: true,
      },
    },
  },
]);

// Renamed function from getCalendar to getScheduler
const getSchedulerPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "manage",
    name: RouteNames.CALENDAR,
    component: Calendar,
    meta: {
      title: "Scheduler",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Scheduler",
        routeName: RouteNames.CALENDAR,
        isStyled: true,
      },
    },
  },
  {
    path: "/",
    name: RouteNames.CONTRACTOR_CALENDAR,
    component: ContractorCalendar,
    meta: {
      title: "Scheduler",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        title: "Scheduler",
        routeName: RouteNames.CONTRACTOR_CALENDAR,
        isStyled: true,
      },
    },
  },
]);

// Renamed function from getCalendar to getScheduler
const getSchedulerPrivateSubmit: GetRelativeRoutes = getChildRoutes([]);

export {
  getSchedulerPrivatePageTabsRoutes,
  getSchedulerPrivateSubmit,
  getSchedulerRoutes,
};
